const firebaseConfig = {
    apiKey: "AIzaSyByqTOMkniyw21CHeLTa6cFoQZALFZsscM",
    authDomain: "hot-godfather-s-resturent.firebaseapp.com",
    databaseURL: "https://hot-godfather-s-resturent.firebaseio.com",
    projectId: "hot-godfather-s-resturent",
    storageBucket: "hot-godfather-s-resturent.appspot.com",
    messagingSenderId: "268967251716",
    appId: "1:268967251716:web:670add9b1240f7d8b40a51"
  };
  export default firebaseConfig;